<div class="row latest-updates">
    <div class="col-md-12">
        <fi-cards *ngIf="resources"
            direction="horizontal" 
            root="document"     
            [resultsize]="resultsize"
            [size]="size"
            [slider]="true"
            view="card"       
            _target="_self"
            autolink="true"
            _category="references.reportingYear"
            [data]="resources">
        </fi-cards>
    </div>
    <div class="col-md-12">
        <fi-cards *ngIf="fisheries"
            direction="horizontal" 
            root="document"     
            [resultsize]="resultsize"
            [size]="size"
            [slider]="true"
            view="card"       
            _target="_self"
            autolink="true"
            _category="references.reportingYear"
            [data]="fisheries">
        </fi-cards>
    </div>
</div>


    <!--  slider="true" -->